import { registerIndicator } from 'klinecharts'

// TradingView-style volume: faded bars anchored to the BOTTOM of the price pane,
// sized as a fraction of the pane height — NOT on the price axis. klinecharts'
// built-in VOL shares the pane's y-axis, so its huge range squashes the candles;
// this custom indicator draws in pixel space instead (no figures → contributes
// nothing to the axis) and only paints. Bar colours come from the indicator's
// extendData ({up, down}) so they re-tint with the theme via overrideIndicator.
const ZONE = 0.16 // bottom fraction of the pane the tallest bar fills

export const VOLUME_INDICATOR = 'VOL_OVERLAY'

interface VolumeDatum {
  vol: number
  up: boolean
}

let registered = false

export function registerVolumeOverlay(): void {
  if (registered) return
  registered = true
  registerIndicator<VolumeDatum>({
    name: VOLUME_INDICATOR,
    shouldOhlc: false,
    figures: [],
    calc: (dataList) =>
      dataList.map((k) => ({ vol: k.volume ?? 0, up: (k.close ?? 0) >= (k.open ?? 0) })),
    draw: ({ ctx, indicator, visibleRange, bounding, barSpace, xAxis }) => {
      if (indicator.visible === false) return false // hidden via the legend eye
      const result = indicator.result || []
      const { from, to } = visibleRange
      let maxVol = 0
      for (let i = from; i < to; i++) {
        const v = result[i]?.vol ?? 0
        if (v > maxVol) maxVol = v
      }
      if (maxVol <= 0) return false
      const zone = bounding.height * ZONE
      const baseY = bounding.height
      const w = Math.max(1, (barSpace?.bar ?? 6) - 2)
      const ext = (indicator.extendData ?? {}) as { up?: string; down?: string }
      const up = ext.up || 'rgba(38,166,154,0.45)'
      const down = ext.down || 'rgba(242,54,69,0.45)'
      ctx.save()
      for (let i = from; i < to; i++) {
        const r = result[i]
        if (!r || !r.vol) continue
        const h = (r.vol / maxVol) * zone
        const x = xAxis.convertToPixel(i)
        ctx.fillStyle = r.up ? up : down
        ctx.fillRect(x - w / 2, baseY - h, w, h)
      }
      ctx.restore()
      return false
    },
  })
}

export function volColors(isDark: boolean): { up: string; down: string } {
  return {
    up: isDark ? 'rgba(38,166,154,0.45)' : 'rgba(22,163,74,0.40)',
    down: isDark ? 'rgba(242,54,69,0.45)' : 'rgba(220,38,38,0.40)',
  }
}
